
import  axios  from 'axios';


export const LOAD_POLICENOTICE_DATA = 'policenotice/LOAD_POLICENOTICE_DATA';
export const DELETE_A_POLICENOTICE = 'policenotice/DELETE_A_POLICENOTICE';
export const SAVE_A_POLICENOTICE = 'policenotice/SAVE_A_POLICENOTICE';
export const UPDATE_A_POLICENOTICE = 'policenotice/UPDATE_A_POLICENOTICE';
export const UPDATE_A_POLICENOTICE_PATH = 'policenotice/UPDATE_A_POLICENOTICE_PATH';




export function loadPolicenoticeDataInStore(argPolicenoticeDataArray) {
    return {
        type: LOAD_POLICENOTICE_DATA,
        policenoticesData:argPolicenoticeDataArray
    }
}
export function deleteAPolicenoticeInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_POLICENOTICE,
        deletePolicenoticeResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAPolicenoticeDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_POLICENOTICE,
        savePolicenoticeResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAPolicenoticeDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_POLICENOTICE,
        updatePolicenoticeResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function getAPolicenoticePathInStore(argFilePath , argErrorMsg) {
    return {
        type: UPDATE_A_POLICENOTICE_PATH,
        filePath:argFilePath,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/

///users/{userid}/companies/{companyid}/towjobs/{jobid}/policenotices/show

export function updateAPolicenoticePath(argURL, argCompanyId, argJobId ) {


    /*var pathURL = argURL+"users/"+state.user.saveUserResp.id+"/companies/"+argCompanyId+"/towjobs/"+argJobId+"/policenotices/show";

    return pathURL*/
   return (dispatch, getState) => {
        const state = getState();

        var pathURL = argURL+"users/"+state.user.saveUserResp.id+"/companies/"+argCompanyId+"/towjobs/"+argJobId+"/policenotices/show"


                dispatch(getAPolicenoticePathInStore(pathURL, {}));


    }//end of return
}
//****************************************
//Below is for update a Stream
//****************************************
export function updateAPolicenotice(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateAPolicenoticeOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateAPolicenoticeDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a company" + err.response.data);
            dispatch(updateAPolicenoticeDataInStore({}, err.response.data));
        });
    }//end of return
}


function updateAPolicenoticeOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAPolicenotice(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAPolicenotice(argURL, argPolicenotice,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/policenotices" ;
    console.log(" on posting a policenotice the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argPolicenotice ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAPolicenotice(argURL, argPolicenoticeInfo, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveAPolicenoticeOnServer(argURL, argPolicenoticeInfo, argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveAPolicenoticeDataInStore(saveResponse, {}));

        }, function(err){
            console.log("I had an error saving a storage lot" + err.response.data);
            dispatch(saveAPolicenoticeDataInStore({}, err.response.data));
        });
    }//end of return
}


function saveAPolicenoticeOnServer( argURL, argPolicenoticeInfo, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAPolicenotice(argURL, argPolicenoticeInfo, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on saving a policenotice " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAPolicenotice(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/policenotices";
    console.log(" on posting a policenotice the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteAPolicenotice(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteAPolicenoticeOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){

            dispatch(deleteAPolicenoticeInStore(deleteResponse, null));

        }, function(err){
            console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAPolicenoticeInStore({}, err));
        });
    }//end of return
}


function deleteAPolicenoticeOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAPolicenotice(argURL, argStreamId, argCompanyId , argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a Policenotice " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAPolicenotice(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/policenotices/"+argStorageId;
    console.log(" on deleteing a Policenotice the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of companys

export function loadPolicenoticesData(argURL, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        getListOfPolicenotices(argURL, state.company.selectedCompany, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(companysList){

            dispatch(loadPolicenoticeDataInStore(companysList));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}

function getArrayOfGetsForListOfPolicenotices(argURL,argCompanyId ,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/policenotices";
    console.log(" on getting list of Policenotices  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfPolicenotices( argURL, argCompanyId ,argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfPolicenotices(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}

/*
function getPolicenoticesDataFromRemoteServer( argURL, argCompanysList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argCompanysList != null){

            axios.all(getArrayOfGets(argURL, argCompanysList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}
*/

/*
function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;


    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Company DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}

*/

/*
export function loadCompanyData(argURL) {
    return (dispatch, getState) => {


        var arrayOfCompanyData=[];
        getListOfCompanys(argURL).then(function(companysList){

            for(var z=0; z<companysList.length; z++){

                let singleResponse = companysList[z];
                let responseData = singleResponse.data;
                getCompanyDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfCompanyData.push(farmsData[i].data);
                    }
                    dispatch(loadCompanyDataInStore(arrayOfCompanyData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */